var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1253_6702",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1253_6702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 17.9163C8.90282 17.9163 7.87171 17.708 6.90671 17.2913C5.94115 16.8747 5.10421 16.3122 4.39587 15.6038C3.68754 14.8955 3.12504 14.0586 2.70837 13.093C2.29171 12.128 2.08337 11.0969 2.08337 9.99967C2.08337 8.90245 2.29171 7.87106 2.70837 6.90551C3.12504 5.94051 3.68754 5.10384 4.39587 4.39551C5.10421 3.68717 5.94115 3.12467 6.90671 2.70801C7.87171 2.29134 8.90282 2.08301 10 2.08301C11.0973 2.08301 12.1287 2.29134 13.0942 2.70801C14.0592 3.12467 14.8959 3.68717 15.6042 4.39551C16.3125 5.10384 16.875 5.94051 17.2917 6.90551C17.7084 7.87106 17.9167 8.90245 17.9167 9.99967C17.9167 11.0969 17.7084 12.128 17.2917 13.093C16.875 14.0586 16.3125 14.8955 15.6042 15.6038C14.8959 16.3122 14.0592 16.8747 13.0942 17.2913C12.1287 17.708 11.0973 17.9163 10 17.9163ZM10 16.6663C11.8473 16.6663 13.4203 16.0172 14.7192 14.7188C16.0175 13.42 16.6667 11.8469 16.6667 9.99967C16.6667 8.15245 16.0175 6.5794 14.7192 5.28051C13.4203 3.98217 11.8473 3.33301 10 3.33301C8.15282 3.33301 6.58004 3.98217 5.28171 5.28051C3.98282 6.5794 3.33337 8.15245 3.33337 9.99967C3.33337 11.8469 3.98282 13.42 5.28171 14.7188C6.58004 16.0172 8.15282 16.6663 10 16.6663Z",
    fill: "#4D4184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97331 13.958C10.1539 13.958 10.3033 13.8991 10.4216 13.7813C10.5394 13.663 10.5983 13.5136 10.5983 13.333V9.77051C10.5983 9.60384 10.5394 9.46134 10.4216 9.34301C10.3033 9.22523 10.1539 9.16634 9.97331 9.16634C9.79275 9.16634 9.64359 9.22523 9.52581 9.34301C9.40747 9.46134 9.34831 9.61079 9.34831 9.79134V13.3538C9.34831 13.5205 9.40747 13.663 9.52581 13.7813C9.64359 13.8991 9.79275 13.958 9.97331 13.958ZM9.97331 7.74967C10.1678 7.74967 10.3275 7.68356 10.4525 7.55134C10.5775 7.41967 10.64 7.25662 10.64 7.06217C10.64 6.88162 10.5775 6.72523 10.4525 6.59301C10.3275 6.46134 10.1678 6.39551 9.97331 6.39551C9.77886 6.39551 9.61914 6.46134 9.49414 6.59301C9.36914 6.72523 9.30664 6.88162 9.30664 7.06217C9.30664 7.25662 9.36914 7.41967 9.49414 7.55134C9.61914 7.68356 9.77886 7.74967 9.97331 7.74967Z",
    fill: "#4D4184"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.65e3e331c8259f817a64a7fff1305a3e.svg";
export { ForwardRef as ReactComponent };